import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { IS_SERVER_PLATFORM, UserSchema, UserService, UserSocket, XeroxMessages } from './core';
import { stepFadeInAnimation } from './feature/payment/utilities';
import { AuthStatusObject, Order } from './shared';
import { ComponentBusService } from './feature/landing/services/component-bus.service';
import { MatSidenav } from '@angular/material/sidenav';
import { ActivationEnd, NavigationEnd, Router } from '@angular/router';
import { Observable, mergeMap } from 'rxjs';
import { BreakpointObserver } from '@angular/cdk/layout';
import { CustomIconService, TitleService } from './feature/services';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [stepFadeInAnimation],
})
export class AppComponent {
  @ViewChild('drawer') drawer!: MatSidenav;

  private connectCount: number = 0;
  public orders: Order[] = [];
  public isAuthenticated: boolean = true;
  private breakpointState!: BreakpointObserver;

  constructor(
    private userSocket: UserSocket,
    private snackbar: MatSnackBar,
    private busService: ComponentBusService,
    private userService: UserService,
    private router: Router,
    private customIconService: CustomIconService,
    private titleService: TitleService,
    @Inject(IS_SERVER_PLATFORM) private isServer: boolean,
  ) {
    const hostName = 'https://ziraxi.com';

    this.titleService.setDefaultTitle();
    this.router.events.subscribe((result) => {
      if (result instanceof ActivationEnd) {
        if (result.snapshot.data?.['description']) {
          // console.log(result.snapshot.data['description']);
          this.titleService.updatePageDescription(result.snapshot.data['description'])
        } else {
          this.titleService.updatePageDescription("زیراکسی، خدمات چاپ دیجیتال و افست را در بالاترین کیفیت و با قیمتی مناسب انجام می‌دهد و در کم‌ترین زمان ممکن به سراسر کشور ارسال می‌کند.")
        }
        // later we will add title for all routes.
      }
      if (result instanceof NavigationEnd) {
        this.titleService.updateCanonicalUrl(hostName + result.url)
      }
    });

    this.isAuthenticated = false;
    this.orders = [];
    this.userSocket.onDisconnect$().subscribe({
      next: () => {
        this.snackbar.open('ارتباط با سرور قطع شد', 'باشه', { duration: 1500 });
      },
    });

    this.userSocket.onConnect$().subscribe({
      next: () => {
        if (this.connectCount > 0)
          this.snackbar.open('اتصال مجدد به سرور برقرار شد !', 'باشه', {
            duration: 1500,
          });

        this.connectCount++;
      },
    });

      if (!!!this.isServer) {
        if (localStorage.getItem('user')) {
          const currentUser = JSON.parse(localStorage.getItem('user') || '');
          if (currentUser && currentUser?.id) {
            this.isAuthenticated = true;
            userService.currentUser.next(currentUser);
          }
        }
      }
  }

  public onAuthentication(authObject: AuthStatusObject) {
    if (!authObject) return;

    this.isAuthenticated = true;
    this.userService.refreshUser(authObject.data as UserSchema);
    this.openDefaultSnackbar(
      XeroxMessages.USER_AUTHORIZATION.success.SUCCESS_LOGIN
    );
  }
  public openDefaultSnackbar(message: string) {
    this.snackbar.open(message, 'باشه', { duration: 1500 });
  }
}
